(function (Digidom, $, undefined) {

    //Public Method
    Digidom.cookieConsent = function (cookieCategory: string) {
        if (!cookieCategory || cookieCategory === '') {
            console.warn('Cookie consent called without category');
            return;
        }
        sendGTMEvent(cookieCategory);
    };

    //Private Method
    function sendGTMEvent(cookieCategory: string) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'ddCookieConsent',
            'ddCookieCategory': cookieCategory
        });
    }
}(window.Digidom = window.Digidom || {}, jQuery));
